"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubMenuItemText = exports.SubMenuItemIcon = exports.SubMenuItemBadges = exports.SubMenuItemAction = exports.SubMenuItem = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Icon = require("../Icon");
var _Text = require("../Text");
var _Truncate = require("../Truncate");
var _SubMenuModule = _interopRequireDefault(require("./SubMenu.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SubMenuItemIcon = _ref => {
  let {
    className,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(_Icon.Icon, _extends({}, props, {
    size: "small",
    color: _Text.TEXT_COLORS.inverseSecondary,
    className: (0, _classify.default)(_SubMenuModule.default.menuIcon, className)
  }));
};
exports.SubMenuItemIcon = SubMenuItemIcon;
SubMenuItemIcon.displayName = 'SubMenuItemIcon';
const SubMenuItemText = _ref2 => {
  let {
    children,
    className,
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement(_Text.ButtonTextMedium, _extends({}, props, {
    className: (0, _classify.default)(_SubMenuModule.default.subMenuItemText, className),
    color: _Text.TEXT_COLORS.inversePrimary
  }), /*#__PURE__*/React.createElement(_Truncate.Truncate, {
    showFullTextOnHover: true
  }, children));
};
exports.SubMenuItemText = SubMenuItemText;
SubMenuItemText.displayName = 'SubMenuItemText';
const SubMenuItemBadges = _ref3 => {
  let {
    children,
    className,
    ...props
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: (0, _classify.default)(_SubMenuModule.default.subMenuItemBadges, className)
  }), children);
};
exports.SubMenuItemBadges = SubMenuItemBadges;
SubMenuItemBadges.displayName = 'SubMenuItemBadges';
const SubMenuItemAction = /*#__PURE__*/React.forwardRef((_ref4, ref) => {
  let {
    children,
    className,
    ...props
  } = _ref4;
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: (0, _classify.default)(_SubMenuModule.default.actionItems, className),
    ref: ref
  }), children);
});
exports.SubMenuItemAction = SubMenuItemAction;
SubMenuItemAction.displayName = 'SubMenuItemAction';
const SubMenuItem = /*#__PURE__*/React.forwardRef((_ref5, ref) => {
  let {
    children,
    selectedMenuKey,
    disabled,
    classNames,
    onChange,
    menuKey,
    ...props
  } = _ref5;
  const onChangeHandler = () => {
    if (!disabled) {
      onChange?.(menuKey);
    }
  };
  const onKeyDownHandler = e => {
    if (e.key === 'Enter') {
      onChangeHandler();
    }
  };
  const selected = selectedMenuKey === menuKey;
  const getNamedComp = comp => {
    const childrenArray = React.Children.toArray(children);
    if (childrenArray.length) {
      const nodes = [];
      for (const child of childrenArray) {
        if (child?.type?.displayName === comp) {
          nodes.push( /*#__PURE__*/React.cloneElement(child, {
            selected,
            disabled
          }));
        }
      }
      return nodes.length > 1 ? nodes : nodes[0];
    }
    return null;
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: (0, _classify.default)(_SubMenuModule.default.menuItem, {
      [_SubMenuModule.default.selected]: selected,
      [_SubMenuModule.default.disabled]: disabled
    }, classNames?.wrapper),
    onKeyDown: onKeyDownHandler,
    onClick: onChangeHandler,
    tabIndex: disabled ? '-1' : 0,
    disabled: disabled,
    ref: ref
  }), /*#__PURE__*/React.createElement("div", {
    className: _SubMenuModule.default.menuIconName
  }, getNamedComp('SubMenuItemIcon'), getNamedComp('SubMenuItemText'), getNamedComp('SubMenuItemBadges')), getNamedComp('SubMenuItemAction'));
});
exports.SubMenuItem = SubMenuItem;